export default __webpack_public_path__ + "static/media/team2.fbd22c75.jpg";